import { render, staticRenderFns } from "./HomeFooterComponent.vue?vue&type=template&id=0f56acc5&"
import script from "./HomeFooterComponent.vue?vue&type=script&lang=js&"
export * from "./HomeFooterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports